export enum GricsEntryImportStatus {
  Created = 'created',
  Modified = 'modified',
  Unchanged = 'unchanged',
  Error = 'error',
}
